import { render, staticRenderFns } from "./ActivityRewards.vue?vue&type=template&id=2999d560&scoped=true&"
import script from "./ActivityRewards.vue?vue&type=script&lang=js&"
export * from "./ActivityRewards.vue?vue&type=script&lang=js&"
import style0 from "./ActivityRewards.vue?vue&type=style&index=0&id=2999d560&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2999d560",
  null
  
)

export default component.exports